import { RouterProvider } from 'react-router-dom';
import { router } from '@/router';
import ErrorBoundary from '@/components/ErrorBoundary';
import { StateManagerProvider } from '@lingugeek/state-management';
import type { StateManagerConfig } from '@lingugeek/state-management';
import { FeatureFlagProvider } from '@lingugeek/ui';

const stateManagerConfig: StateManagerConfig = {
  apiBaseUrl:
    import.meta.env.VITE_API_BASE_URL ||
    (import.meta.env.PROD
      ? 'https://api.lingugeek.com'
      : 'http://localhost:3001'),
  queryDefaults: {
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: false,
    retry: 2,
  },
  auth: {
    tokenRefreshThreshold: 5 * 60 * 1000, // 5 minutes
    maxRetries: 3,
  },
};

export default function App() {
  return (
    <ErrorBoundary>
      <FeatureFlagProvider
        config={{
          envOverrides: {
            ENABLE_SUBSCRIPTIONS:
              import.meta.env.VITE_ENABLE_SUBSCRIPTIONS || 'false',
          },
        }}
      >
        <StateManagerProvider
          config={stateManagerConfig}
          onAuthRequired={() => {
            // Handle unauthorized access - redirect to login
            // Only redirect if we're not already on login page
            if (window.location.pathname !== '/login') {
              window.location.href = '/login';
            }
          }}
          onAuthRefresh={async () => {
            // Try to refresh authentication
            try {
              const response = await fetch(
                `${stateManagerConfig.apiBaseUrl}/auth/refresh`,
                {
                  method: 'POST',
                  credentials: 'include',
                }
              );
              return response.ok;
            } catch {
              return false;
            }
          }}
        >
          <RouterProvider router={router} />
        </StateManagerProvider>
      </FeatureFlagProvider>
    </ErrorBoundary>
  );
}
